<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <modal :name="modalName" width="100%" :clickToClose="false" height="940px" @before-open="beforeOpen" @before-close="beforeClose">
      <v-card>
          <v-toolbar card color="white">
              <div class="flex xs12 sm2">
                  <v-select
                          :items="[{
                          text: '승객 고유번호',
                          value: 'id'
                        },
                        {
                          text: '전화번호',
                          value: 'phoneNumber'
                        },
                        {
                          text: '이름',
                          value: 'name'
                        },
                        {
                          text: '성별',
                          value: 'gender'
                        },
                        {
                          text: '사용상태',
                          value: 'state'
                        }]"
                          name="header"
                          v-model="searchFormModel.filter"
                          label="header"
                  ></v-select>
              </div>

              <div class="flex xs12 sm2" v-show="searchFormModel.filter === 'gender'">
                  <v-select
                          :items="gender"
                          label="선택"
                          item-text="text"
                          item-value="state"
                          single-line
                          v-model="searchFormModel.filterText"
                  >
                  </v-select>
              </div>

              <div class="flex xs12 sm2" v-show="searchFormModel.filter === 'state'">
                  <v-select
                          :items="state"
                          label="선택"
                          item-text="text"
                          item-value="state"
                          single-line
                          v-model="searchFormModel.filterText"
                  >
                  </v-select>
              </div>

              <v-text-field
                      v-show="searchFormModel.filter !== 'state' && searchFormModel.filter !== 'gender'"
                      flat
                      solo
                      prepend-icon="search"
                      placeholder="Type something"
                      v-model="searchFormModel.filterText"
                      hide-details
                      class="hidden-sm-and-down"
                      @keyup.enter="searchFilter"
              ></v-text-field>
              <v-btn icon @click="searchFilter">
                  <v-icon>filter_list</v-icon>
              </v-btn>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text class="pa-0">
              <v-data-table
                      :headers="complex.headers"
                      :items="complex.items"
                      :rows-per-page-items="[10,25,50]"
                      class="elevation-1"
                      item-key="id"
                      must-sort
                      :total-items="totalItems"
                      :pagination.sync="pagination"
                      v-model="complex.selected"
              >
                  <template slot="items" slot-scope="props">
                      <td>
                          <v-checkbox
                                  primary
                                  hide-details
                                  v-model="selectedIds"
                                  :value="props.item.id"
                          ></v-checkbox>
                      </td>
                      <td class="text-sm-center">{{ props.item.id }}</a></td>
                      <td class="text-sm-center" >{{ props.item.personalInfo.name }}</td>
                      <td class="text-sm-center" >{{ props.item.personalInfo.birthDay }}</td>
                      <td class="text-sm-center" >{{ props.item.personalInfo.gender === 'M' ? '남자' : '여자' }}</td>
                      <td class="text-sm-center" >{{ props.item.phoneNumber }}</td>
                      <td class="text-sm-center" >{{ props.item.regDate }}</td>
                  </template>
              </v-data-table>
          </v-card-text>
          <v-card-actions>
              <v-spacer>
              </v-spacer>
              <v-btn color="blue darken-1" flat @click="apply">적용</v-btn>
              <v-btn color="blue darken-1" flat @click="closeModal">닫기</v-btn>
          </v-card-actions>
      </v-card>
  </modal>
</template>

<script>
  import State  from '@/api/state';
  import Gender  from '@/api/gender';

  export default {
    components: {},
    data : function() {
      return {
          pagination: {
              sortBy: 'id',
              descending: true,
              rowsPerPage: 10,
              page: 1
          },
          searchFormModel: {
              filter: 'id',
              filterText: ''
          },
          totalItems: 0,
          complex: {
              selected: [],
              headers: [
                  {
                      text: '승객 고유번호',
                      value: 'id',
                      align: 'center'
                  },
                  {
                      text: '이름',
                      value: 'name',
                      sortable: false,
                      align: 'center'
                  },
                  {
                      text: '생년월일',
                      value: 'birthDay',
                      sortable: false,
                      align: 'center'
                  },
                  {
                      text: '성별',
                      value: 'gender',
                      sortable: false,
                      align: 'center'
                  },
                  {
                      text: '휴대전화번호',
                      value: 'phoneNumber',
                      align: 'center'
                  },
                  {
                      text: '가입일',
                      value: 'regDate',
                      align: 'center'
                  },
                  {
                      text: '사용 상태',
                      value: 'state',
                      align: 'center'
                  },
              ],
              items: []
          },
          selectedIds: [],
          state: State,
          gender: Gender,
          callback: null
      }
    },
    props : {
      modalName: {
        required: false,
        default: 'modal-passenger-selector',
      }
    },
    watch: {
      pagination: {
          handler () {
              this.banbanCreated();
          },
          deep: true
      },
      'searchFormModel.filter' () {
          this.searchFormModel.filterText = '';
      }
    },
    mounted () {

    },
    methods: {
      beforeOpen (e) {
          if(e.params.callback) {
              this.callback = e.params.callback;
          }
      },
      beforeClose () {
        this.clearModalData();
      },
      clearModalData() {
        this.pagination = {
              sortBy: 'id',
              descending: true,
              rowsPerPage: 10,
              page: 1
        };
        this.searchFormModel = {
              filter: 'id',
              filterText: ''
        };
        this.complex.items = [];
        this.complex.selected = [];
        this.selectedIds = [];
        this.totalItems = 0;
        this.callback = null;
      },
      closeModal () {
        this.beforeClose();
        this.$modal.hide(this.modalName);
      },
      apply () {
          if(this.callback !== null) {
              this.callback(this.selectedIds);
          }

          this.closeModal();
      },
        banbanCreated () {
            const parameters = {
                method: 'searchPassengers',
                pageNum: this.pagination.page - 1,
                pageSize: this.pagination.rowsPerPage,
                sortName: this.pagination.sortBy,
                order: this.pagination.descending == true ? 'desc' : 'asc',
                filter: this.searchFormModel.filter,
                filterText: this.searchFormModel.filterText
            };
            this.$store.dispatch('banbanAPI', parameters)
                .then(({ data }) => {
                    if (data.statusCode != null && data.statusCode != '200'){
                        throw data.message;
                    }

                    this.complex.items = data.content;
                    this.totalItems = data.totalElements;
                    top.getApp.progress.dialog = false;
                })
                .catch((error) => {
                    if (top.getApp.commonError == null) {
                        alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
                    }
                    top.getApp.commonError = null;
                    top.getApp.progress.dialog = false;
                });
        },
      searchFilter () {
        this.banbanCreated();
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/modal/modal-passenger-selector.vue